import { Box, colorsPalette, styled } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import CharactersSvg from './assets/characters.svg?component';
import HandleSvg from './assets/handle.svg?component';
import type { ErrorLayoutProps } from './LayoutWrappers';

interface Props {
    errorType: ErrorLayoutProps['errorType'];
}

export const CharactersBubbles = ({ errorType }: Props) => (
    <>
        <Box
            position="absolute"
            top={{ xs: '90px', md: '180px' }}
            sx={{ fontWeight: 700, fontSize: { xs: '182px', md: '350px' }, color: 'white' }}
        >
            {errorType}
        </Box>
        <Box
            position="absolute"
            top={{ xs: '-60px', md: '70px' }}
            width={{ xs: '450px', md: '785px' }}
            sx={{ transform: { xs: 'scale(0.8) translate(4%, 0)', sm: 'none' } }}
        >
            <CharactersSvg width="100%" />
            <Box
                sx={{
                    transform: { xs: 'rotate(115deg)', md: 'rotate(115deg)', lg: 'rotate(150deg)' },
                    position: 'absolute',
                    left: { xs: '28%', md: '39%', lg: '39%' },
                    top: { xs: '77%', md: '102%', lg: '66%' },
                }}
            >
                <HandleSvg />
            </Box>
            <DialogBubble
                sx={{
                    transform: 'translate(-100%, 0)',
                    left: { xs: '40%', md: '56%', lg: '40%' },
                    top: { xs: '81%', md: '106%', lg: '60%' },
                }}
            >
                {errorType === 400 && trans('notFound-mistake', {}, 'public-common')}
                {errorType === 404 && trans('notFound-page-not-exist', {}, 'public-common')}
                {errorType === 500 && trans('notFound-mistake', {}, 'public-common')}
            </DialogBubble>
            <Box
                sx={{
                    transform: { xs: 'rotate(65deg)', md: 'rotate(65deg)', lg: 'rotate(0deg)' },
                    position: 'absolute',
                    left: { xs: '73%', md: '72%', lg: '74%' },
                    top: { xs: '78%', md: '102%', lg: '79%' },
                }}
            >
                <HandleSvg />
            </Box>
            <DialogBubble
                sx={{
                    left: { xs: '58%', md: '72%', lg: '78%' },
                    top: { xs: '81%', md: '106%', lg: '74%' },
                }}
            >
                {errorType === 400 && trans('notFound-happens', {}, 'public-common')}
                {errorType === 404 && trans('notFound-mygoodness', {}, 'public-common')}
                {errorType === 500 && trans('notFound-happens', {}, 'public-common')}
            </DialogBubble>
        </Box>
    </>
);

const DialogBubble = styled(Box)(({ theme }) => ({
    width: 'max-content',
    backgroundColor: 'white',
    color: colorsPalette.darkblueSolid[100],
    textAlign: 'center',
    lineHeight: 1.75,
    fontWeight: 600,
    borderRadius: 75,
    position: 'absolute',

    fontSize: 20,

    padding: theme.spacing(2.5, 4),
    maxWidth: '330px',

    [theme.breakpoints.down('md')]: {
        fontSize: 14,
        padding: theme.spacing(1.5, 2),
        maxWidth: '180px',
    },
}));
